'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialGithub = function TiSocialGithub(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.1 21.6c0.4 0 0.8 0.2 1.1 0.7 0.3 0.4 0.5 1 0.5 1.6 0 0.6-0.2 1.2-0.5 1.6-0.3 0.5-0.7 0.7-1.1 0.7-0.5 0-0.9-0.2-1.2-0.7-0.4-0.4-0.5-1-0.5-1.6 0-0.6 0.1-1.2 0.5-1.6 0.3-0.5 0.7-0.7 1.2-0.7z m5.7-5.9c1.2 1.3 1.9 3 1.9 4.9 0 1.3-0.2 2.4-0.5 3.4-0.3 1-0.6 1.8-1.1 2.4-0.4 0.6-0.9 1.2-1.6 1.7-0.6 0.4-1.2 0.8-1.8 1-0.5 0.2-1.1 0.4-1.8 0.5-0.7 0.1-1.2 0.2-1.6 0.2-0.3 0-0.7 0-1.1 0-0.1 0-0.4 0-0.9 0.1-0.5 0-1 0-1.3 0s-0.8 0-1.3 0c-0.5-0.1-0.8-0.1-0.9-0.1-0.4 0-0.8 0-1.1 0-0.4 0-0.9-0.1-1.6-0.2-0.7-0.1-1.3-0.3-1.8-0.5-0.6-0.2-1.2-0.6-1.8-1-0.7-0.5-1.2-1.1-1.6-1.7-0.5-0.6-0.8-1.4-1.1-2.4-0.3-1-0.5-2.1-0.5-3.4 0-1.9 0.7-3.6 1.9-4.9-0.1-0.1-0.1-0.8 0-2 0.1-1.3 0.4-2.5 0.8-3.6 1.6 0.2 3.5 1.1 5.8 2.6 0.8-0.2 1.8-0.3 3.2-0.3 1.4 0 2.5 0.1 3.2 0.3 1-0.7 2-1.2 3-1.7 1-0.4 1.7-0.7 2.1-0.7l0.7-0.2c0.4 1.1 0.7 2.3 0.8 3.6 0.1 1.2 0.1 1.9 0 2z m-9.7 13c2.8 0 4.9-0.3 6.3-1 1.4-0.7 2.2-2.1 2.2-4.1 0-1.3-0.5-2.3-1.4-3.1-0.5-0.4-1-0.7-1.6-0.8-0.7-0.1-1.6-0.1-2.9 0-1.3 0.1-2.2 0.1-2.7 0.1-0.6 0-1.3 0-2.2-0.1-0.8 0-1.5-0.1-2-0.1-0.5 0-1 0.1-1.6 0.2-0.6 0.1-1 0.4-1.4 0.7-0.9 0.8-1.3 1.8-1.3 3.1 0 2 0.7 3.4 2.1 4.1 1.4 0.7 3.5 1 6.3 1h0.1z m-4.1-7.1c0.4 0 0.8 0.2 1.1 0.7 0.4 0.4 0.5 1 0.5 1.6 0 0.6-0.1 1.2-0.5 1.6-0.3 0.5-0.7 0.7-1.1 0.7-0.5 0-0.9-0.2-1.2-0.7-0.3-0.4-0.5-1-0.5-1.6 0-0.6 0.2-1.2 0.5-1.6 0.3-0.5 0.7-0.7 1.2-0.7z' })
        )
    );
};

exports.default = TiSocialGithub;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-github.js
// module id = 3197
// module chunks = 0